import { colors } from '../../../../../../../../../colorVars';
import { Body3 } from '../../../../../../../../../components/atomic/text/Text';

export function cannotConfirmOrderCancelledBuilder({parsedStatusObj}) {
  return (
    <td>
      <Body3 fontWeight={500} color={colors.lightGrey}>
        Cannot confirm cancellation of order #{parsedStatusObj.orderId}.
      </Body3>
    </td>
  );
}
